import {Userpilot} from 'userpilot';

export const userpilotObject = ({user, platform, application}) => {
  if (!platform) {
    return {};
  }

  const basicData = {
    application,
    company: {
      id: platform.platformSlug,
      host: platform.platformSlug,
      site: platform.domain?.slug,
      sitename: platform.domain?.name
    }
  };

  if (!user) {
    return basicData;
  }

  const teamNames = user.teams?.map(teamMember => teamMember.team.name) ?? [];
  const teamRoles = user.teams?.map(teamMember => teamMember.role) ?? [];

  const roleFlags = {
    isAdmin: teamRoles.includes('ADMIN'),
    isEditor: teamRoles.includes('EDITOR'),
    isPlatformAdmin: user.isPlatformAdmin,
    isSuperPlatformAdmin: user.isIPA
  };

  return {
    name: user.fullName,
    email: user.email,
    created_at: user.dateCreated,
    teamNames,
    teamRoles: roleFlags,
    ...basicData
  };
};

export const trackEvent = (key, metadata) => {
  Userpilot.track(key, metadata);
};
